<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<div class="float_img_left_1-4_1"><img alt="" src="images/P-010-1.jpg"/></div>
<div class="float_img_left_1-4_1"><img alt="" src="images/P-010-2.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom018.vue?e47fe188